<script>
export default {
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      scrollbarSize: 0
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth <= 699.9
    }
  },
  created () {
    const handler = () => {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    window.dispatchEvent(new Event('resize'))
  },
  mounted () {
    const scrollBox = document.getElementById('scroll-box')
    this.scrollbarSize = scrollBox.offsetWidth - scrollBox.clientWidth
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/responsitive.vue